export default __webpack_public_path__ + "static/media/landing-identity.93d5fd50.png";